import React from 'react';

import { IBaseProps } from '../../utils';

import { ILabelProps, Label } from '../../Label';
import { Text } from '../../Text';

import styles from './FormItem.module.scss';

export interface IFormItemProps extends IBaseProps {
  /** Displays a description of the form field below the label */
  description?: string;
  /** Switches label and description styles to disabled. Form field will need to be passed its own disabled value. */
  disabled?: boolean;
  /** ID of form field to be associated with label. */
  htmlFor?: string;
  /** Text value for label of form field */
  label: string | ILabelProps;
  /** Displays required label. Form field will need to be passed its own required value. */
  required?: boolean;
}

export const FormItem: React.FC<IFormItemProps> = (props) => {
  const labelProps = typeof props.label === 'string' ? { children: props.label } : props.label;

  const { children, ...label } = {
    htmlFor: props.htmlFor,
    disabled: props.disabled,
    ['data-test']: `${props.dataTest}-label`,
    ...labelProps
  };

  return (
    <div className={props.className} data-test={props.dataTest}>
      <div className={styles.labelContainer}>
        <Label {...label}>
          {children} {props.required && <span data-test="requiredLabel">(Required)</span>}
        </Label>

        {props.description && (
          <Text
            className={styles.description}
            size="small"
            color={props.disabled ? 'disabled' : 'light'}
            data-test={`${props.dataTest}-description`}
          >
            {props.description}
          </Text>
        )}
      </div>
      {props.children}
    </div>
  );
};

FormItem.displayName = 'FormItem';
